module.exports = __webpack_public_path__ + "static/media/fingerprint.1d1ecc7f.svg";